import { Favorite } from 'data/records'
import { resource, findSelector } from 'data/helpers/apiv3'
import { pascalCase } from 'lib/textUtils'

const [api, actions] = resource(Favorite, [])

// I don't think it's possible to do a thunk
// with our DSL-based actions api, so we define it the normal way here
// with JS
actions.toggle = (objectType, objectId, source = 'web') => (dispatch, getState) => {
  const favorite = selectors.favoriteForObject(getState(), objectType, objectId)
  favorite
    ? dispatch(actions.delete(favorite.id))
    : dispatch(actions.create(Favorite({
      favoritedObjectId: objectId,
      favoritedObjectType: pascalCase(objectType),
      source
    })))
}

// NOTE: in rwgps-ui, we've historically used snake_case for objectType
// (trip, route, event, ride_report). The backend uses PascalCase.
// I'm transforming the case here in the selector, but this is probably
// a mismatch that will bite us eventually.
// I support a refactor in rwgps-ui to use PascalCase for
// any prop named objectType
const selectors = {
  ...findSelector(Favorite),
  favoriteForObject: (state, objectType, objectId) => (
    state.apiv3.favorite.id.find(
      f => f.favoritedObjectId === objectId && f.favoritedObjectType === pascalCase(objectType)
    )
  )
}

const reducers = {}

const initialState = {}

export {
  api as favoriteApi,
  actions as favoriteActions,
  selectors as favoriteSelectors,
  reducers as favoriteReducers,
  initialState as favoriteInitialState
}
